import { render } from "./LGPD.vue?vue&type=template&id=2ecfcd0e&scoped=true"
import script from "./LGPD.vue?vue&type=script&lang=js"
export * from "./LGPD.vue?vue&type=script&lang=js"

import "./LGPD.vue?vue&type=style&index=0&id=2ecfcd0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecfcd0e"]])

export default __exports__